// extracted by mini-css-extract-plugin
module.exports =  {"tc-badge-faceted":"BadgeFaceted-module__tc-badge-faceted___DHyq_","tc-badge-faceted-overlay":"BadgeFaceted-module__tc-badge-faceted-overlay___TKkVf"};